import React, { useState} from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import {useDispatch, useSelector} from "react-redux";
import { ReactComponent as AliPayIcon } from '../../../assets/img/alipay.svg'
import {useHistory, useLocation} from "react-router-dom";
import Description from '../../Common/Typography/description'
import ImageButton from '../../Common/Buttons/imageButton'
import TextBox from '../../Common/Textbox/small'
import { ReactComponent as  WeChatIcon } from '../../../assets/img/wechat.svg'
import "../../../styles/main.css"
 

const PaymentContainer = ({profileUrl,token,handleLoading}) => {
  const loading = true;
  return (
    <div className={"paymentContainer"}>
      <div className={"paymentWrapper"}>

          <Description addClass={"BOLD_STYLE span"} text={`Enter the amount you would like to pay`} />


          <div className={"infoContainer"}>
            <div className={"inputContainer"}>

                <TextBox loading={loading}  placeholder="" error={false} value={""} type={"text"}
                      tName={"name"} label={"Student Name"} additionClass={'EMPHASIS_LARGE smallInput'} htmlFor="outlined-basic-name" />

            </div>
            <div style={{width: '32px'}}/>
            <div className={"inputContainer inputAmount"}>
                <TextBox loading={loading}  placeholder="" error={false} value={""} type={"number"}
                       tName={"amount"} label={"Amount (USD)"} additionClass={'EMPHASIS_LARGE smallInput'}
                       htmlFor="outlined-basic-amount"
                       InputProps={{
                        endAdornment: <InputAdornment className="endadornment" position="end">$</InputAdornment>,
                       }}
                       />
            </div>
          </div>
            <div className={"paymentButtonsContainer"}>
              <ImageButton
                  loading={loading}
                  additionClass={'disabled bg-light-green' }
                  text={`Pay Now`}
                  Icon={<WeChatIcon fill="#fff" />}                  
               >
              </ImageButton>
                                <ImageButton
                 loading={loading}
                  additionClass={'bg-light-blue'}
                  text={`Pay using Alipay`}
                  Icon={<AliPayIcon fill="#fff"  />}
              >
              </ImageButton>
              
            </div>

      </div>
    </div>
  );
}

export default PaymentContainer;
